export default __webpack_public_path__ + "static/dooc-e-174429285d9a64406e1095eefdcd7c5c.jpeg";